import React from "react";
import FormGroupTextInput from "../formGroupTextInput";
import {
    APPLICATION_FORM_FIELDS,
    CANADA_COUNTRY,
    COUNTRY,
    DATE_REGEX_DD_MM_YYYY,
    DEFAULT_MEDICAL_EXPERT_FEE, DROPZONE_ACCEPTED_FILES,
    INVALID_DATES_ERROR_MESSAGE
} from "../../helpers/variables";
import FormGroupSelectInput from "../formGroupSelectInput";
import FormGroupDate from "../formGroupDate";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";
import Dropzone from "react-dropzone";
import AttachmentsList from "../General/attachmentsList";
import ApplicationQuestion from "./applicationQuestion";
import {isAragUser} from "../../helpers/functions";
import { checkWhichQuestionTriggeredConditional } from "../../helpers/questions/functions";

const FullApplicationForm = (props) => {
    const {
    } = props;


    return (
        <form className="form-horizontal" onSubmit={props.HandleSubmit} autoComplete="off">
            <FormGroupTextInput
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name}
                Required={true}
                Name="solicitorFileReference"
                Type="text"
                Value={props.Store.solicitorFileReference}
                HandleInputChange={props.ChangeNewAppField}
            />
            {
                (props.workSourceOptions.length > 1 && COUNTRY != CANADA_COUNTRY)?
                    <FormGroupSelectInput
                        Label={APPLICATION_FORM_FIELDS.WORK_SOURCE.name}
                        LeftWrapper={"col-sm-3"}
                        Required={props.user.loggedInUser.requiredWorkSource}
                        Name="workSourceId"
                        Value={props.Store.workSourceId}
                        Options={props.workSourceOptions}
                        HandleInputChange={props.HandleInputChange}
                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                        RightWrapper=""
                        SelectStyle={'form-control formGroupSelectInput-select'}
                    />
                    :
                    null
            }
            <hr className="generalTab-hr"/>
            <FormGroupTextInput
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={APPLICATION_FORM_FIELDS.CLIENT_NAME.name}
                Required={true}
                Name="clientName"
                Type="text"
                Value={props.Store.clientName}
                HandleInputChange={props.ChangeNewAppField}
            />
            <FormGroupDate
                title={INVALID_DATES_ERROR_MESSAGE}
                pattern={DATE_REGEX_DD_MM_YYYY}
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name}
                Required={true}
                Name="dateOfBirth"
                Key="dateOfBirth"
                Max={props.maxDateOfBirth}
                Type="text"
                Value={props.Store.dateOfBirth}
                HandleInputChange={props.HandleDateChange}/>
            <FormGroupTextInput
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={APPLICATION_FORM_FIELDS.ADDRESS.name}
                Required={true}
                Name="address"
                Type="text" Value={props.Store.address}
                HandleInputChange={props.ChangeNewAppField}/>
            <FormGroupTextInput
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={APPLICATION_FORM_FIELDS.POST_CODE.name}
                Required={true}
                Name="postCode"
                Type="text" Value={props.Store.postCode}
                HandleInputChange={props.ChangeNewAppField}/>
            {
                Object.keys(props.groupedQuestions).map( (key, index) => {
                    return <div key={index}>
                        <hr className="generalTab-hr"/>
                        {
                            props.groupedQuestions[key]
                                .map((question, index) => {
                                return (
                                    <ApplicationQuestion
                                        opponentQuestions={props.Store.opponentQuestions}
                                        onOpponentAdd={() => props.ChangeNewAppField('extraOpponents', [...props.Store.extraOpponents, {
                                            name: '',
                                            prospectsOptionId: '',
                                            insuredOptionId: '',
                                            satisfiedOptionId: ''
                                        }])}
                                        removeExtraOpponent={props.RemoveExtraOpponent}
                                        extraOpponents={props.Store.extraOpponents}
                                        updateExtraOpponents={props.UpdateExtraOpponents}
                                        removeMedicalExpertFeesTableRow={props.removeMedicalExpertFeesTableRow}
                                        onMedicalFeeAdd={() => props.ChangeNewAppField('medExpertFees', [...props.Store.medExpertFees, DEFAULT_MEDICAL_EXPERT_FEE])}
                                        isPlain={false}
                                        medExpertFees={props.Store.medExpertFees}
                                        updateMedicalExpertFees={props.updateMedicalExpertFees}
                                        breachCausationCp={props.breachCausationCp}
                                        filedDisabled={((Object.keys(props.Store.selectedApplication).length !== 0 && props.Store.selectedApplication.constructor === Object) && props.Store.selectedApplication.policyStatus !== 'Draft') }
                                        onDrop={props.OnDrop}
                                        handleDateChange={props.HandleDateChange}
                                        questions={props.Store.questions}
                                        key={question.id}
                                        textAreaRows={8}
                                        question={question}
                                        formData={props.Store.formData}
                                        handleSelectChange={props.HandleSelectChange}
                                        handleTextInputChange={props.HandleFormCompChange}
                                        onClickActionLink={props.onClickActionLink}
                                    />
                                );
                            })
                        }
                        {props.Store.triggeredQuestionsToDisplay && props.Store.triggeredQuestionsToDisplay.map(conditionalQuestion => {
                           var triggerQuestionsGroupIds = checkWhichQuestionTriggeredConditional(props.Store.formData,props.Store.questions,conditionalQuestion);
                           var istriggered = triggerQuestionsGroupIds.length > 0 && conditionalQuestion.groupSortOrder == key;
                            if (istriggered) {
                                return (
                                    <ApplicationQuestion
                                        isPlain={false}
                                        onDrop={props.OnDrop}
                                        onClickActionLink={props.onClickActionLink}
                                        handleDateChange={props.HandleDateChange}
                                        questions={props.Store.questions}
                                        key={conditionalQuestion.id}
                                        textAreaRows={8}
                                        question={conditionalQuestion}
                                        formData={props.Store.formData}
                                        handleSelectChange={props.HandleSelectChange}
                                        handleTextInputChange={props.HandleFormCompChange}
                                        filedDisabled={((Object.keys(props.Store.selectedApplication).length !== 0 && props.Store.selectedApplication.constructor === Object) && props.Store.selectedApplication.policyStatus !== 'Draft')}
                                    />
                                )
                            }
                        })}
                    </div>
                })
            }
            
            {
                (!props.Store.duplicate ) ?
                    <div className="form-group">
                        <div className="col-sm-3">
                        </div>
                        <div className="col-sm-6">
                        {!isAragUser(props.user.loggedInUser.roles) ?
                            <Button clickHandler={props.HandleSave}
                                    wrapper="btn-wrapper-forForms"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                    label="Save Progress"/>
            :null}
                            {
                                props.UserRole === 'Solicitor'||isAragUser(props.user.loggedInUser.roles) ?
                                    <Button wrapper="btn-wrapper-forForms"
                                            btnType="submit"
                                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                            label="Submit Application"/>
                                    :
                                    null
                            }
                        </div>
                    </div>
                    :
                    <div>
                        <FormGroupTextInput
                            autoComplete={'off'}
                            InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                            Label="Confirmation"
                            Required={true}
                            Name="confirmation"
                            Type="text"
                            Value={props.Store.confirmation}
                            HandleInputChange={props.ChangeNewAppField}
                        />
                        <div className="form-group">
                            <div className="col-sm-5 col-sm-offset-3">
                                <Button
                                    clickHandler={() => {
                                        props.ChangeNewAppField('duplicate', false);
                                    }}
                                    wrapper="btn-wrapper-forForms"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                    label="Cancel"/>
                                <Button
                                    wrapper="btn-wrapper-forForms"
                                    btnType="submit"
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label="Confirm"
                                />
                            </div>
                        </div>
                    </div>
            }
            {props.Store.posting && (
                <div className="form-group">
                    <div className="col-sm-12"><CenteredDots/></div>
                </div>
            )}
            { props.Store.badMsg !== '' && (
                <FormResponseMessage
                    LeftWrapper="col-sm-3"
                    CenterWrapper="col-sm-6"
                    MessageStyle="formResponseMessage-reject"
                    Message={props.Store.badMsg}
                />
            )}
            {props.Store.msg !== '' && (
                <FormResponseMessage
                    LeftWrapper="col-sm-3"
                    CenterWrapper="col-sm-6"
                    MessageStyle="formResponseMessage-success"
                    Message={props.Store.msg}/>
            )}
            <div className="form-group">
                <div className="col-sm-6 col-sm-offset-3">
                    <Dropzone onDropAccepted={(files) => props.OnDrop(files)} accept={DROPZONE_ACCEPTED_FILES}
                              disabled={((Object.keys(props.Store.selectedApplication).length !== 0 && props.Store.selectedApplication.constructor === Object) && props.Store.selectedApplication.policyStatus !== 'Draft')}
                              className="newApplication-dropzone">
                        <p>Try dropping some files here, or click to select files to upload.</p>

                    </Dropzone>
                    <AttachmentsList
                        attachments={props.Store.attachments || []}
                        onAttachmentRemove={(attachment, index) => props.AttachmentRemove(index)}
                    />
                    {
                        props.Store.attachmentsForDisplay.length > 0 ?
                            <div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <hr className="appFormRefSettings-hr"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <h4 className="col-sm-12 ">Files Already Attached.</h4>
                                </div>
                                <AttachmentsList
                                    onAttachmentRequest={(attachment) => {
                                        props.requestApplicationAttachment({
                                            applicationId: props.Store.selectedApplication.id,attachmentId:attachment.id,
                                            relativeUrl: attachment.relativeUrl
                                        });
                                    }}
                                    attachments={props.Store.attachmentsForDisplay}
                                    onAttachmentRemove={(attachment) => props.requestDeleteDocument(props.Store.patchedApplication.id, attachment.id, attachment.relativeUrl)}
                                />
                            </div>
                            :
                            null
                    }
                </div>
            </div>
        </form>
    )
};

export default FullApplicationForm;